<template>
  <v-container id="industry" tag="section">
    <v-col lg="12" md="12" sm="12">
      <v-row class="back">
        <v-col class="col-xs-6" md="6">
          <v-btn class="float-left" color="primary" @click="$router.back(-1)">
            <v-icon>apps</v-icon>
            {{ $t('global.goBack') }}
          </v-btn>
        </v-col>
        <v-col class="col-xs-6">
        </v-col>
      </v-row>

      <v-row dense>
        <div class="main-content">
          <template v-if="!Array.isArray(termDescription)">
            <p v-html='termDescription'></p>
          </template>

          <template v-else>

          </template>

          <h3 class="industry-title">{{ $t('industry.products_recommended') }}</h3>
          <v-row id="industry-filter">

            <v-col
              class="d-flex"
              cols="6"
              sm="3"
            >
              <v-select
                v-model="selectedIndustry_1"
                :items="taxonomyIndustry_1"
                item-text="name"
                item-value="tid"
                :label="$t('global.pleaseSelect')"
                return-object
                dense
                outlined
                hide-details="auto"
                @change="selectedChange(1, selectedIndustry_1, 3)"
              ></v-select>
            </v-col>

            <v-col
              class="d-flex"
              cols="6"
              sm="3"
              v-if="taxonomyIndustry_2.length"
            >
              <v-select
                v-model="selectedIndustry_2"
                :items="taxonomyIndustry_2"
                item-text="name"
                item-value="tid"
                :label="$t('global.pleaseSelect')"
                return-object
                dense
                outlined
                hide-details="auto"
                @change="selectedChange(2, selectedIndustry_2, 4)"
              ></v-select>
            </v-col>

            <v-col
              class="d-flex"
              cols="6"
              sm="3"
              v-if="taxonomyIndustry_3 && taxonomyIndustry_3.length"
            >
              <v-select
                v-model="selectedIndustry_3"
                :items="taxonomyIndustry_3"
                item-text="name"
                item-value="tid"
                :label="$t('global.pleaseSelect')"
                return-object
                dense
                outlined
                hide-details="auto"
                @change="selectedChange(3, selectedIndustry_3, 5)"
              ></v-select>
            </v-col>

            <v-col
              class="d-flex"
              cols="6"
              sm="3"
              v-if="taxonomyIndustry_4 && taxonomyIndustry_4.length"
            >
              <v-select
                v-model="selectedIndustry_4"
                :items="taxonomyIndustry_4"
                item-text="name"
                item-value="tid"
                :label="$t('global.pleaseSelect')"
                return-object
                dense
                outlined
                hide-details="auto"
                @change="selectedChange(4, selectedIndustry_4, 6)"
              ></v-select>
            </v-col>

            <v-col
              class="d-flex"
              cols="6"
              sm="3"
              v-if="taxonomyIndustry_5 && taxonomyIndustry_5.length"
            >
              <v-select
                v-model="selectedIndustry_5"
                :items="taxonomyIndustry_5"
                item-text="name"
                item-value="tid"
                :label="$t('global.pleaseSelect')"
                return-object
                dense
                outlined
                hide-details="auto"
                @change="selectedChange(5, selectedIndustry_5)"
              ></v-select>
            </v-col>

            <v-col
              class="d-flex"
              cols="6"
              sm="3"
              v-if="taxonomyIndustry_6 && taxonomyIndustry_6.length"
            >
              <v-select
                v-model="selectedIndustry_6"
                :items="taxonomyIndustry_6"
                item-text="name"
                item-value="tid"
                :label="$t('global.pleaseSelect')"
                return-object
                dense
                outlined
                hide-details="auto"
                @change="selectedChange(6, selectedIndustry_6)"
              ></v-select>
            </v-col>

            <v-col
              class="d-flex"
              cols="6"
              sm="3"
              v-if="taxonomyIndustry_7 && taxonomyIndustry_7.length"
            >
              <v-select
                v-model="selectedIndustry_7"
                :items="taxonomyIndustry_7"
                item-text="name"
                item-value="tid"
                :label="$t('global.pleaseSelect')"
                return-object
                dense
                outlined
                hide-details="auto"
                @change="selectedChange(7, selectedIndustry_7)"
              ></v-select>
            </v-col>
          </v-row>

        </div>
      </v-row>

      <product-list></product-list>

<!--      <v-row class="footer">-->
<!--        <v-col class="col-xs-6" md="6">-->
<!--          <v-btn class="float-left" color="primary" @click="goClick('formulations', termTid)">-->
<!--            {{ $t('industry.checkFormulation') }}-->
<!--            <v-icon>play_arrow</v-icon>-->
<!--          </v-btn>-->
<!--        </v-col>-->
<!--        <v-col class="col-xs-6">-->
<!--          <v-btn class="float-right" color="primary" @click="goClick('products', termTid)">-->
<!--            {{ $t('industry.checkProduct') }}-->
<!--            <v-icon>play_arrow</v-icon>-->
<!--          </v-btn>-->
<!--        </v-col>-->
<!--      </v-row>-->
    </v-col>
  </v-container>
</template>

<script>
  import {mapState} from "vuex"
  import $ from 'jquery'
  import productList from "../components/products/productList"
  import {globalUtils} from "../utils/globalUtils";

  export default {
    name: 'industry',

    components: { productList },

    data() {
      return {
        selectedIndustry_1: {},
        taxonomyIndustry_2: [],
        selectedIndustry_2: {},
        taxonomyIndustry_3: [],
        selectedIndustry_3: {},
        taxonomyIndustry_4: [],
        selectedIndustry_4: {},
        taxonomyIndustry_5: [],
        selectedIndustry_5: {},
        taxonomyIndustry_6: [],
        selectedIndustry_6: {},
        taxonomyIndustry_7: [],
        selectedIndustry_7: {},
        distance: -Infinity,
        infiniteId: +new Date(),
        productList: [],
      }
    },

    computed: {
      ...mapState({
        termDetail: state => state.industry.termDetail,
        isLogin: state => state.user.isLogin,
        taxonomyIndustry_1: state => state.core.taxonomyProductApplication,
      }),
      termDescription: function () {
        return (this.termDetail && this.termDetail.field_application_description) ? this.termDetail.field_application_description : []
      },

      termTid: function () {
        return (this.termDetail && this.termDetail.tid) ? this.termDetail.tid : []
      },
    },

    watch: {
      $route(to, from) {
        this.loadTermDetail();
      }
    },

    created() {
      this.loadTermDetail()
    },

    mounted() {},

    methods: {
      loadTermDetail() {
        let vm = this
        let query = vm.$router.history.current.query
        let term_id = query.industry

        if (!term_id) {
          term_id = 4
        }
        vm.$loading.show()

        // 永远显示至少第二层的行业
        let parentIndustryItem = globalUtils.findParentTid(vm.taxonomyIndustry_1, term_id)
        let industryTid = term_id
        if (parentIndustryItem.depth >= 2) {
          industryTid = vm.getSecondLevel(parentIndustryItem)
        }

        // 如果进入时的行业在第三层以后那么必须获取其父级第二层的行业解释和内容
        if ((parentIndustryItem.depth >= 2 && Array.isArray(vm.termDescription)) || parentIndustryItem.depth < 2) {
          vm.$store.dispatch('getTaxonomyDetail',{term_type: 'applacation', term_id: industryTid}).then(result => {
            if (result.status === 200) {
              if ($('.main-content img').length > 0) {
                let imgs = $('.main-content img')
                imgs.each((index, img) => {
                  let align = $(img).attr('data-align')

                  if (align) {
                    $(img).addClass('align-' + align)
                  }
                })
              }
            }

            vm.$loading.hide()
          })
        }

        vm.$store.dispatch('getTaxonomyParents', {term_type: 'applacation', term_id: term_id}).then(result => {
          if (result.status === 200) {
            // 进入页面后，默认选择行业过滤
            result.data.parent_level.forEach((item, key) => {
              let selectedIndustry = 'selectedIndustry_' + (key + 1)
              let selectedIndustry_sub = 'taxonomyIndustry_' + (key + 2)
              let currentItem = globalUtils.findItemFromIndustry(vm.taxonomyIndustry_1, item)

              this[selectedIndustry] = currentItem
              this[selectedIndustry_sub] = currentItem.children
            })
          }
        })
      },

      clearSelected(depth) {
        for (let i = depth; i <= 7; i++) {
          let taxonomyIndustry = 'taxonomyIndustry_' + i
          let selectedIndustry = 'selectedIndustry_' + i
          let selectedIndustry_1 = 'selectedIndustry_' + (i - 1)

          this[taxonomyIndustry] = []
          this[selectedIndustry] = {}
          this[selectedIndustry_1] = {}
        }
      },

      selectedChange(index, selectedIndustry, depth = null) {
        this.$router.push({ path: '/industry', query: {industry: selectedIndustry.tid}})

        if (index !== 7 || index !== 6) {
          this.clearSelected(depth)
        }

        if (index !== 7) {
          this['taxonomyIndustry_' + (index + 1)] = selectedIndustry.children
        }

        setTimeout(function () {
          let top = document.getElementById('industry-filter').offsetTop

          window.scrollTo({
            top: top,
            left: 0,
            behavior: 'smooth'
          });
        }, 700)



      },

      goClick(path, tid) {
        // this.$router.push({ path: path, query: {industry: tid}})

        // 从vue 无刷新改为刷新跳转
        window.location.href = `/${path}/?industry=${tid}`
      },

      getSecondLevel(term) {
        let vm = this
        let parentIndustryItem = globalUtils.findParentTid(vm.taxonomyIndustry_1, term.tid)
        if (term.depth === 2) {
          return term.tid
        }

        if (term.depth > 2) {
          return vm.getSecondLevel(parentIndustryItem)
        }
      }
    }
  }
</script>

<style lang="scss">
  #industry {

    h1, h2, h3, h4, h5 {
      font-weight: bold;
    }

    .main-content {
      width: 100%;
      background-color: #fff;
      padding: 15px 15px 0;
      border-radius: 5px;

      p {
        font-size: 16px !important;
      }

      .teaser-container {

        .caption {
          left: auto;
        }
      }

      .list-product {
        padding-left: 350px;

        @media screen and (max-width: 480px) {
          padding-left: 15px;
        }
      }

      .content {
        float: left;
        background-color: #ddd;
        width: 200px;
        margin-right: 20px;

        ul {
          list-style: square;
        }

      }
    }

    .industry-top {
      display: flex;
      flex-wrap: wrap;

      .image-wrapper {
        width: 30%;
        height: auto;

        img {
          width: 100% !important;
          object-fit: contain;
          object-position: left top;

          &.center {
            object-position: center center;
          }

          &.left-top {
            object-position: left top;
          }

          &.left-bottom {
            object-position: left bottom;
          }

          &.right-top {
            object-position: right top;
          }

          &.right-bottom {
            object-position: right top;
          }

          @media screen and (max-width: 768px) {
            width: 100% !important;
          }
        }

        @media screen and (max-width: 480px) {
          width: 100%;
        }
      }

      .content-intro {
        padding-left: 30px;
        flex: 1;

        @media screen and (max-width: 480px) {
          padding-left: 0;
        }

        h1 {
          margin-top: 0 !important;
        }
      }

      @media screen and (max-width: 768px) {
        padding: 0 15px !important;
      }
    }

    .contact-container {
      padding: 0;

      h2 {
        margin-bottom: 6px;
      }
    }

    .contact-wrapper {
      display: flex;
      flex-direction: column;

      .contact {
        flex: 1;
        display: flex;
        min-height: 29px;

        p {
          margin-right: 10px;
          margin-bottom: 0;
        }
        .email {
          position: relative;
          padding-left: 25px;

          &:before {
            content: '';
            position: absolute;
            background: url("../assets/industry/mail.svg");
            width: 20px;
            height: 20px;
            background-size: cover;
            left: 0;
          }
        }
      }
    }

    .industry-title {
      padding: 0 25px;
      margin-bottom: 15px;

      @media screen and (max-width: 768px) {
        padding: 0 5px;
      }
    }

    #industry-filter {
      padding: 0 25px;

      & > div.col-6 {
        padding-bottom: 0;
      }

      @media screen and (max-width: 768px) {
        padding: 0 5px;
      }
    }
  }
</style>
